import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserService } from 'app/core/user/user.service';
import { listedplace } from 'app/types/listedplace.type';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BudgetPrivateQuoteService{
  private _data = new BehaviorSubject<any>(null);
  $dataDefault = this._data.asObservable();
  airporttransferForm: FormGroup;

  private apiURL = this.baseUrl + 'api/customer';
  isLoading$ = new BehaviorSubject<boolean>(false);
  constructor(
      private http: HttpClient,
      @Inject('BASE_URL') private baseUrl: string
      ,private cookieService: CookieService
    ) {
        try{
            // console.log(this.cookieService.get('airporttransferForm'));
            // this._tranferData = new BehaviorSubject<any>( JSON.parse(this.cookieService.get('airporttransferForm')));
            // this.$dataDefault = this._tranferData.asObservable();
        }
        catch{

        }
     }

    setTranferData(data: FormGroup) {
      this._data.next(data.getRawValue());
    //   this.cookieService.set( 'airporttransferForm', JSON.stringify(data.getRawValue()));
    }

    getTranferData$(): Observable<any> {
      return this._data.asObservable();
    }

    GetNumberReserve(model: any): Observable<any> {
      this.isLoading$.next(true);
      let headers = new HttpHeaders();
      headers.set('content-type', 'application/x-www-form-urlencoded');
      return  this.http.get<any>(this.apiURL + '/getnumberreserve', {params:model} );
    }

    GetAirportReserve(model: any): Observable<any> {
      this.isLoading$.next(true);
      let headers = new HttpHeaders();
      headers.set('content-type', 'application/x-www-form-urlencoded');
      return  this.http.get<any>(this.apiURL + '/getreserveairport', {params:model} );
    }
    getlistedplaces(): Observable<any>{
          //this.isLoading$.next(true);

          // return this.http.get<any>(this.apiURL + '/getlistedplaces').pipe(
          //   tap((response) => {
          //     this._listedplace.next(response);
          //   })
          // );
          return this.http.get<any>(this.apiURL + '/getlistedplaces');
          // return this.http.get(this.apiURL + '/getlistedplaces')
          //          .toPromise()
          //          .then(response => response.json().data as listedplace[])
          //          .catch(this.handleError);
      }

      getlistedprivateplaces(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedprivateplaces');
      }
      getlistedairlines(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedairlines');
      }
      getlistedoperators(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedoperators');
      }
      getlisteddrivers(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlisteddrivers');
      }
      getlistedvehicles(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedvehicles');
      }
      getlistedstatusbyreserve(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedstatusbyreserve');
      }
      getlistedterminals(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getlistedterminals');
      }
      getconfrangedatestimes(): Observable<any>
      {
          return this.http.get<any>(this.apiURL + '/getconfrangedatestimes');
      }

      getcustomeragencies(codeuser: any): Observable<any> {
       // this.isLoading$.next(true);
        return this.http.get<any>(this.apiURL + '/getcustomeragencies', {params:codeuser});
      }
      getmodulerequirementcodes(module: any): Observable<any> {
        // this.isLoading$.next(true);
         return this.http.get<any>('api/account' + '/getmodulerequirementcodes', {params:module});
       }

       getlevelaccessreserve(model: any): Observable<any> {
        // this.isLoading$.next(true);
         return this.http.get<any>(this.apiURL + '/getlevelaccessreserve', {params:model});
       }

       NewModifyReserveAirport(model: any): Promise<any> {
          this.isLoading$.next(true);

          return new Promise((resolve, reject) => {
            this.http.post(this.apiURL + '/addupdatereserveairport', model)
                .subscribe((response: any) => {
                    resolve(response);
                },
                    (error) => {
                        this.isLoading$.next(false);
                        reject(error);
                    },
                    () => {
                        this.isLoading$.next(false);
                    });
          });

        }

      NewModifyALLReserve(model: any): Promise<any> {
      this.isLoading$.next(true);
      return new Promise((resolve, reject) => {
          this.http.post(this.apiURL + '/addupdateentirereserveairport', model)
              .subscribe((response: any) => {
                  resolve(response);
              },
                  (error) => {
                      this.isLoading$.next(false);
                      reject(error);
                  },
                  () => {
                      this.isLoading$.next(false);
                  });
      });
      }

      ConfirmBookingCustomer(model: any): Promise<any> {
          this.isLoading$.next(true);
          return new Promise((resolve, reject) => {
            this.http.post(this.apiURL + '/confirmbookingcustomer', model)
                .subscribe((response: any) => {
                    resolve(response);
                },
                    (error) => {
                        this.isLoading$.next(false);
                        reject(error);
                    },
                    () => {
                        this.isLoading$.next(false);
                    });
          });
        }

        NewFullPrivateBookingConfirmedCustomer(model: any): Promise<any> {
            this.isLoading$.next(true);
            return new Promise((resolve, reject) => {
              this.http.post(this.apiURL + '/newFullPrivateBookingConfirmedCustomer', model)
                  .subscribe((response: any) => {
                      resolve(response);
                  },
                      (error) => {
                          this.isLoading$.next(false);
                          reject(error);
                      },
                      () => {
                          this.isLoading$.next(false);
                      });
            });
          }

        ConfirmBookingAdmin(model: any): Promise<any> {
          this.isLoading$.next(true);
          return new Promise((resolve, reject) => {
            this.http.post(this.apiURL + '/saveconfirmbookingadmin', model)
                .subscribe((response: any) => {
                    resolve(response);
                },
                    (error) => {
                        this.isLoading$.next(false);
                        reject(error);
                    },
                    () => {
                        this.isLoading$.next(false);
                    });
          });
        }

        GetLinkCalendarArrival(model: any):Promise<any>{
          this.isLoading$.next(true);
          let headers = new HttpHeaders();
          headers.set('content-type', 'application/x-www-form-urlencoded');
         return new Promise((resolve, reject) => {
              this.http.post(this.apiURL + '/getlinkcalendararrivalreserve', model)
                  .subscribe((response: any) => {
                      resolve(response);
                  },
                      (error) => {
                          this.isLoading$.next(false);
                          reject(error);
                      },
                      () => {
                          this.isLoading$.next(false);
                      });
            });
        }

        GetLinkCalendarDeparture(model: any):Promise<any>{
          this.isLoading$.next(true);
          let headers = new HttpHeaders();
          headers.set('content-type', 'application/x-www-form-urlencoded');
         return new Promise((resolve, reject) => {
              this.http.post(this.apiURL + '/getlinkcalendardeparturereserve', model)
                  .subscribe((response: any) => {
                      resolve(response);
                  },
                      (error) => {
                          this.isLoading$.next(false);
                          reject(error);
                      },
                      () => {
                          this.isLoading$.next(false);
                      });
            });
        }

        UserCodeRecoveryByEmail(model: any): Promise<any> {
          this.isLoading$.next(true);

          return new Promise((resolve, reject) => {
            this.http.post(this.apiURL + '/usercoderecoverybyemail', model)
                .subscribe((response: any) => {
                    // console.log(response);
                    resolve(response);

                },
                    (error) => {

                        this.isLoading$.next(false);
                        reject(error);
                    },
                    () => {
                        this.isLoading$.next(false);
                    });
          });

        }

      //   NewReservePrivateTransportation(model: any): Promise<any> {
      //     this.isLoading$.next(true);
      //     // return new Promise((resolve, reject) => {
      //     //     this.http.post(this.apiURL + '/newcontact', model)
      //     //         .subscribe((response: any) =>
      //     //             resolve(response));


      //     //         // ,
      //     //         //     (error) => {
      //     //         //         this.isLoading$.next(false);
      //     //         //         reject(error);
      //     //         //     },
      //     //         //     () => {
      //     //         //         this.isLoading$.next(false);
      //     //         //     }
      //     //             // );
      //     // });

      //     return new Promise((resolve, reject) => {
      //       this.http.post(this.apiURL + '/newreserveprivatetransportation', model)
      //           .subscribe((response: any) => {
      //               // console.log(response);
      //               resolve(response);

      //           },
      //               (error) => {

      //                   this.isLoading$.next(false);
      //                   reject(error);
      //               },
      //               () => {
      //                   this.isLoading$.next(false);
      //               });
      //     });

      //   }

        GetBookingPrice(model: any): Observable<any> {
          this.isLoading$.next(true);
          let headers = new HttpHeaders();
          headers.set('content-type', 'application/x-www-form-urlencoded');
          return  this.http.get<any>(this.apiURL + '/getbookingprice', {params:model}

          );
        }
        
        NewBookingPrivateNoPriceQuote(model: any): Promise<any> {
            this.isLoading$.next(true);
           
        
            return new Promise((resolve, reject) => {
              this.http.post(this.apiURL + '/newBookingPrivateNoPriceQuote', model)
                  .subscribe((response: any) => {
                      resolve(response);
                  },
                      (error) => {
                          this.isLoading$.next(false);
                          reject(error);
                      },
                      () => {
                          this.isLoading$.next(false);
                      });
            });
              
          }

          

          UpdateEntireBookingPrivateQuote(model: any): Promise<any> {
            this.isLoading$.next(true);
            return new Promise((resolve, reject) => {
              this.http.post(this.apiURL + '/updateEntireBookingPrivateQuote', model)
                  .subscribe((response: any) => {
                      resolve(response);
                  },
                      (error) => {
                          this.isLoading$.next(false);
                          reject(error);
                      },
                      () => {
                          this.isLoading$.next(false);
                      });
            });
          }

}